import actionTypes from './actionTypes';

export const fetch = (filters = {}, append = false) => ({
  type: actionTypes.FETCH,
  payload: {
    filters,
    append,
  },
});

export const fetchNext = (filters = {}, append = false) => ({
  type: actionTypes.FETCH_NEXT,
  payload: {
    filters,
    append,
  },
});

export const fetchPrev = (filters = {}) => ({
  type: actionTypes.FETCH_PREV,
  payload: {
    filters,
  },
});

export const fetching = append => ({
  type: actionTypes.FETCHING,
  payload: {
    append,
  },
});

export const fetched = (data = [], meta = {}) => ({
  type: actionTypes.FETCHED,
  payload: {
    data,
  },
  meta,
});

export const cache = (key, payload) => ({
  type: actionTypes.CACHE,
  payload: {
    key,
    payload,
  },
});
